"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomRadioButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiTheme = require("@kyruus/ui-theme");
var _styles = require("./styles");
const StyledRadioButton = /*#__PURE__*/(0, _base.default)('div', process.env.NODE_ENV === "production" ? {
  target: "eaa6nha0"
} : {
  target: "eaa6nha0",
  label: "StyledRadioButton"
})(">input[type='radio']{", _styles.hiddenStyles, ";}>label{text-indent:unset;line-height:normal;padding:0;}&:focus-within>input:not(:checked)+label>div{color:", props => (0, _uiTheme.fromTheme)(props.focusTextColor), ";background:", props => (0, _uiTheme.fromTheme)(props.focusBackgroundColor), ";>div:nth-child(2)>div{color:", props => (0, _uiTheme.fromTheme)(props.focusTextColor), ";}}&:focus-within>input+label>div{outline-color:", props => (0, _uiTheme.fromTheme)(props.focusOutlineColor), ";outline-width:", props => (0, _uiTheme.fromTheme)(props.focusOutlineWidth), ";outline-style:", props => (0, _uiTheme.fromTheme)(props.focusOutlineStyle), ";outline-offset:", props => (0, _uiTheme.fromTheme)(props.focusOutlineOffset), ";}>input:disabled+label *{cursor:not-allowed;background-color:", (0, _uiTheme.fromTheme)('color_button_disabled'), ";border-color:", (0, _uiTheme.fromTheme)('color_button_disabled'), ";color:", (0, _uiTheme.fromTheme)('color_text_button_disabled'), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const CustomRadioButton = _ref => {
  let {
    name,
    option,
    checked,
    onChange,
    RenderOption,
    RenderSelectedOption,
    focusTextColor,
    focusBackgroundColor,
    focusOutlineColor,
    focusOutlineWidth,
    focusOutlineStyle,
    focusOutlineOffset
  } = _ref;
  const id = name == null ? option.value : `${name}-${option.value}`;
  return /*#__PURE__*/_react.default.createElement(StyledRadioButton, {
    focusTextColor: focusTextColor,
    focusBackgroundColor: focusBackgroundColor,
    focusOutlineColor: focusOutlineColor,
    focusOutlineWidth: focusOutlineWidth,
    focusOutlineStyle: focusOutlineStyle,
    focusOutlineOffset: focusOutlineOffset
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    id: id,
    name: name,
    value: option.value,
    checked: checked,
    onChange: onChange,
    "data-testid": `radio-${id}`,
    disabled: option.disabled,
    "aria-checked": checked,
    "aria-label": option.label,
    "aria-describedby": option.ariaDescribedby
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    "data-testid": `radio-label-${id}`
  }, checked ? /*#__PURE__*/_react.default.createElement(RenderSelectedOption, {
    option: option
  }) : /*#__PURE__*/_react.default.createElement(RenderOption, {
    option: option
  })), option.description);
};
exports.CustomRadioButton = CustomRadioButton;
CustomRadioButton.propTypes = {
  /**
   * The name property to apply to the form group
   */
  name: _propTypes.default.string,
  /**
   * Whether or not the radio is checked
   */
  checked: _propTypes.default.bool,
  /**
   * Callback for handling changes to the selected radio button
   * args: (event, optionString)
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * The option to create the radio buttons for.
   * Example: {value: 'f', label: 'Female'}
   */
  option: _propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    ariaDescribedby: _propTypes.default.string,
    /** An element containing a descriptive text for screen readers */
    description: _propTypes.default.node,
    disabled: _propTypes.default.bool
  }).isRequired,
  /**
   * A renderer for the body of the label that displays to the user when it is not selected
   */
  RenderOption: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * A renderer for the body of the label that displays to the user when it is selected
   */
  RenderSelectedOption: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Text color for when the component is focused ~but unchecked~
   */
  focusTextColor: _propTypes.default.string,
  /**
   * Background color for when the component is focused ~but unchecked~
   */
  focusBackgroundColor: _propTypes.default.string,
  focusOutlineColor: _propTypes.default.string,
  /**
   * Outline width for when the component is focused and checked or unchecked
   */
  focusOutlineWidth: _propTypes.default.string,
  /**
   * Outline style for when the component is focused and checked or unchecked
   */
  focusOutlineStyle: _propTypes.default.string,
  /**
   * Outline offset for when the component is focused and checked or unchecked
   */
  focusOutlineOffset: _propTypes.default.string
};
CustomRadioButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CustomRadioButton",
  "props": {
    "name": {
      "description": "The name property to apply to the form group",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "checked": {
      "description": "Whether or not the radio is checked",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "description": "Callback for handling changes to the selected radio button\nargs: (event, optionString)",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "option": {
      "description": "The option to create the radio buttons for.\nExample: {value: 'f', label: 'Female'}",
      "type": {
        "name": "shape",
        "value": {
          "value": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          },
          "ariaDescribedby": {
            "name": "string",
            "required": false
          },
          "description": {
            "name": "node",
            "description": "An element containing a descriptive text for screen readers",
            "required": false
          },
          "disabled": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": true
    },
    "RenderOption": {
      "description": "A renderer for the body of the label that displays to the user when it is not selected",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "RenderSelectedOption": {
      "description": "A renderer for the body of the label that displays to the user when it is selected",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "focusTextColor": {
      "description": "Text color for when the component is focused ~but unchecked~",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusBackgroundColor": {
      "description": "Background color for when the component is focused ~but unchecked~",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineColor": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineWidth": {
      "description": "Outline width for when the component is focused and checked or unchecked",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineStyle": {
      "description": "Outline style for when the component is focused and checked or unchecked",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineOffset": {
      "description": "Outline offset for when the component is focused and checked or unchecked",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};